import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";
import { Tag, Icon, Layout, Row, Table, Tooltip } from "antd";
import { withNamespaces } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

import classes from "./DocumentManagementDashboard.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { getDocumentDashboardMissingPerSiteListRequest } from "../../api/requests";
import { logout } from "../../reducers/user/actions";

class MissingDocumentsPerSite extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      missingPerSite: [],
    };
  }

  async componentDidMount() {
    this.getData();
  }

  getData = async () => {
    this.setState({ isLoading: true });
    try {
      const [missingPerSite] = await Promise.all([
        getDocumentDashboardMissingPerSiteListRequest(),
      ]);
      this.setState({
        missingPerSite: missingPerSite.data,
      });
    } catch (e) {
      console.log(e);
    }

    this.setState({ isLoading: false });
  };

  render() {
    const { isLoading } = this.state;

    const columns = [
      {
        dataIndex: "primary_category",
        key: "primary_category",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Primary Category"),
      },
      {
        dataIndex: "sub_category",
        key: "sub_category",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Sub Category"),
      },
      {
        dataIndex: "content_type",
        key: "content_type",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Content Type"),
      },
      {
        dataIndex: "sites_missing",
        key: "sites_missing",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Missing In"),
        render: (val) => (
          <div>
            {map(val.split("|"), (site) => (
              <Tag color="#2db7f5" style={{ margin: '3px' }}>{site}</Tag>
            ))}
          </div>
        ),
      },
    ];

    return (
      <div>
        <h4 className="headline-default">
          {this.props.i18n.t("NamespaceDocumentsDashboard:Missing documents per site")}
        </h4>

        {isLoading && <Icon type="loading" />}
        {!isLoading && (
          <div>
            <Table
              columns={columns}
              dataSource={this.state.missingPerSite}
              loading={isLoading}
              rowKey={() => uuidv4()}
              pagination={false}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(MissingDocumentsPerSite))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentManagementDashboard/MissingDocumentsPerSite.js